// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
function MetricListItem({ metricCategory }) {
  return (
    <li>
      <Link className="metricCategory-title" to={`/admin/authoring/metric-categories/${metricCategory._id}`}>{metricCategory.title} </Link>
      {metricCategory.order ? 
        <small><em> &mdash; order weight: {metricCategory.order}</em></small>
        :
        null
      }
    </li>
  )
}

MetricListItem.propTypes = {
  metricCategory: PropTypes.object.isRequired
}

export default MetricListItem;



// WEBPACK FOOTER //
// modules/metricCategory/components/MetricCategoryListItem.js.jsx